import m, {Vnode} from "mithril";
import {TextareaItem} from "../../model/items/textarea";

export function progressBarThermometerView(c:TextareaItem): Vnode|null {
    if (!c.thermometer || !c.cell.enabled || !c.cell.isVisible()) {
        return null;
    }

    const wordCount = c.wordCount();
    const levels = c.thermometer.levels;
    const step = c.thermometer.step;
    const level = levels[Math.min(Math.floor(wordCount / step), levels.length-1)];
    const progress = Math.max(Math.min(wordCount / ((levels.length-1) * step), 1), 0.01);

	return m('.progressBar-thermometer', {
	    style: { backgroundColor: level.color }
    }, [
        m('.progressBar-progress', {}, [
            m('.progressBar-progress-filled', {
                style: {
                    width: (progress*100)+'%',
                    backgroundColor: level.color,
                }
            }),
        ]),
		m('.progressBar-body', {
            style: { color: level.color }
        }, m.trust(c.questionary.renderText(level.label))),
	]);
}
